import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { ReplenishmentRunResource } from "@exonn/js-sdk";
import { formatDateTime } from "@exonn/utils";
import { Suggestions } from "src/admin/modules/replenishment-run/forms/replenishment-run/tabs/suggestions/Suggestions.tsx";

// Bestellvorschläge: прогон считается в фоне, предложения правятся и превращаются в заказы поставщику.
export const module: ModuleOptions<ReplenishmentRunResource> = {
  resource: ResourceEnum.ReplenishmentRun,
  // Вкладка Vorschläge читает данные прогона из контекста формы.
  layoutForm: true,
  bigIcon: <i className="icon-20-selling" />,
  smallIcon: <i className="icon-15-selling" />,
  disableDelete: true,

  tabs: {
    edit: {
      getTitle: (resource) =>
        [resource.owner?.company_name, formatDateTime(resource.created_at)]
          .filter(Boolean)
          .join(" · "),
    },
  },

  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    suggestions: {
      title: (t) => t("formTabs.suggestions.title"),
      routeObject: {
        Component: Suggestions,
      },
      isHidden: ({ data }) => !data?.id,
    },
  },
};
